(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', '$rootScope','$scope','Idle','$uibModal','$uibModalStack'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService, $rootScope,$scope,Idle,$uibModal,$uibModalStack) {
        var vm = this;

        vm.isAdmin;
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });
        var copyAccount = function (account) {
            return {
                displayName: account.displayName,
            };
        };
        Principal.identity().then(function(account) {
            vm.accountDetails = copyAccount(account);
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.checkUser = checkUser;
        vm.$state = $state;

        vm.navbar = {
        		fullAccessRoles: "Administrators",
        		adminMenuRoles: "Administrators,DAC Content Administrator,DAC Content User",
        		astbMenuRoles: "Administrators,Billing Administrator,Billing User",
        		dacMenuRoles: "Administrators,DAC Content Administrator,DAC Content User",
        		reportsMenuRoles: "Administrators,DAC Content Administrator,DAC Content User,Customer Users"
        	};
        if(Principal.isAuthenticated())
        {

            Idle.watch();

            $rootScope.$on('IdleStart', function () {
                $uibModal.open({
                    templateUrl: 'app/idleSessionTimeOut.html',
                    windowClass: 'modal-danger',
                    backdrop: false,
                    controller: ['$scope', '$uibModalInstance',
                        function($scope, $uibModalInstance) {
                            $rootScope.ok=function(){
                                $uibModalStack.dismiss($uibModalStack.getTop().key);
                                Idle.watch();
                            }
                            $rootScope.logout=function(){
                                $uibModalStack.dismissAll();
                                Idle.unwatch();
                                Auth.logout();
                                $state.go('sign-out-home-page', {}, {
                                    reload : true
                                });
                                LoginService.open();
                            }
                        }]
                });

            });
            $rootScope.$on('IdleEnd', function() {

                $uibModalStack.dismiss($uibModalStack.getTop().key);


            });

            $rootScope.$on('IdleTimeout', function () {


                $uibModalStack.dismiss($uibModalStack.getTop().key);
                Idle.unwatch();
                Auth.logout();
                $state.go('sign-out-home-page', {}, {
                    reload : true
                });
                LoginService.open();
            });
        }else {
            Idle.unwatch();
        }

        function login() {
            collapseNavbar();
            LoginService.open();

        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('sign-out-home-page', {}, {
				reload : true
			});
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function checkUser() {
        	var adminAuthorities = ['Administrators'];
            Principal.hasAuthority(Principal.findHasAnyAuthority(adminAuthorities)).then(function(result){
                vm.isAdmin  = result;

                if(vm.isAdmin === true && Principal.isAuthenticated()){
                    $state.go('home-main.home-page', {}, {
                        reload : false
                    });
                }
                else if(vm.isAdmin===false && Principal.isAuthenticated()){
                    $state.go('user-home-page', {}, {
                        reload : false
                    });
                }
                else{
                    $state.go('sign-out-home-page', {}, {
                        reload : false
                    });
                }
            });


        }
    }
})();
